import PropTypes from 'prop-types';
import React from 'react';
import AriAvatar from 'containers/Ari/AriAvatar';
import { trackEvent } from 'helpers/Analytics';
import styles from './JobsBestMatchCard.module.scss';

/**
 * In-list Best match entry point for the jobs board.
 * Shown to every visitor (guest, logged-in, Pro) at a fixed list index.
 */
const JobsBestMatchCard = ({
  pageType,
  auth,
  filterCount,
  onBestMatchNavigate,
}) => {
  const handleBestMatch = (event) => {
    event.preventDefault();
    trackEvent('jobs-best-match-clicked', {
      source: 'in_list',
      pageType,
      auth,
      filterCount,
    });
    if (onBestMatchNavigate) {
      onBestMatchNavigate();
    }
  };

  return (
    <aside
      className={styles.card}
      data-testid="jobs-best-match-card"
      aria-label="Try Best match"
    >
      <AriAvatar size={40} className={styles.avatar} />
      <div className={styles.copy}>
        <h3 className={`${styles.heading} ${styles.headingDesktop}`}>
          Want these ordered by what fits you?
        </h3>
        <h3 className={`${styles.heading} ${styles.headingMobile}`}>
          Order these by what fits you?
        </h3>
        <p className={styles.body}>
          Best match uses Ari to rank jobs against your CV and explain each one.
        </p>
      </div>
      <a
        href="/ari"
        className={styles.button}
        onClick={handleBestMatch}
        data-testid="jobs-best-match-in-list"
      >
        Try Best match
      </a>
    </aside>
  );
};

JobsBestMatchCard.propTypes = {
  pageType: PropTypes.oneOf(['jobs', 'role', 'country']).isRequired,
  auth: PropTypes.oneOf(['guest', 'logged_in']).isRequired,
  filterCount: PropTypes.number,
  onBestMatchNavigate: PropTypes.func,
};

JobsBestMatchCard.defaultProps = {
  filterCount: 0,
  onBestMatchNavigate: undefined,
};

export default JobsBestMatchCard;
